import { render, staticRenderFns } from "./totalDocument.vue?vue&type=template&id=beeb5892&scoped=true&"
import script from "./totalDocument.vue?vue&type=script&lang=js&"
export * from "./totalDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beeb5892",
  null
  
)

export default component.exports